export default "__VITE_ASSET__DwufLRzv__"